import axios from "axios";
import { ref } from "vue";
import { v4 as uuidv4 } from 'uuid';

export function useAudioWorker(timeline, logUrl, preview = false) {
    const podcastId = ref(null)
    const episodeId = ref(null)
    const episodeDuration = ref(null)
    const previousSecond = ref(0)
    const deviceId = ref(uuidv4())

    const sendTrackingData = async (data, seconds = timeline.value.currentTime) => {
        if (!timeline.value.duration || preview) {
            return
        }

        let localSeconds = Math.ceil(seconds);
        let localPreviousSecond = Math.ceil(previousSecond.value);

        if ('play' in data || 'scroll' in data || 'resume' in data) {
            previousSecond.value = localSeconds;
        }

        let second = 0;
        let previous_second = 0;

        if (Object.keys(data).length > 0 ) {
            second = previous_second = localSeconds;
        } else {
            previousSecond.value = localPreviousSecond;

            previous_second = localPreviousSecond;
            second = localSeconds;
        }

        if (!second) {
            second = 0;
        }

        if (!previous_second) {
            previous_second = 0;
        }

        const request = axios.post(logUrl, {
            podcast: podcastId.value,
            episode: episodeId.value,
            duration: episodeDuration.value,
            second: second,
            previous_second: previous_second,
            actions: data,
            device: deviceId.value
        })

        return request
    }

    return {
        podcastId,
        episodeId,
        episodeDuration,
        previousSecond,
        deviceId,
        sendTrackingData,
    }
}
